import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const MediaCaption = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* MEDIA CAPTIONS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Media Captions</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Caption</label>
            <figure>
              <div className="bg-slate-800 h-32 rounded mb-2 flex items-center justify-center text-slate-500">[Image]</div>
              <figcaption className="text-xs text-slate-400">A beautiful landscape photo taken at sunset</figcaption>
            </figure>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<figure>
  <img src="image.jpg" />
  <figcaption className="text-xs text-slate-400">
    Caption text
  </figcaption>
</figure>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Caption with Credit</label>
            <figure>
              <div className="bg-slate-800 h-32 rounded mb-2 flex items-center justify-center text-slate-500">[Image]</div>
              <figcaption className="text-xs text-slate-400">
                <span>Mountain landscape at dawn</span>
                <br/>
                <span className="text-slate-600"> 2024 John Smith</span>
              </figcaption>
            </figure>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<figcaption className="text-xs">
  <span>Caption</span>
  <br/>
  <span className="text-slate-600"> Credit</span>
</figcaption>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Overlay Caption</label>
            <div className="relative">
              <div className="bg-slate-800 h-40 rounded flex items-center justify-center text-slate-500">[Image]</div>
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black to-transparent rounded-b">
                <p className="text-slate-100 text-sm font-medium">Desert dunes</p>
                <p className="text-xs text-slate-400">Shot with a wide angle lens</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <img className="w-full" />
  <div className="absolute bottom-0 bg-gradient-to-t from-black p-3">
    <p>Caption</p>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Icon + Caption</label>
            <figure className="text-center">
              <div className="text-4xl mb-2"></div>
              <figcaption className="text-xs">
                <p className="text-slate-300 font-medium">Photo Gallery</p>
                <p className="text-slate-500">Click to view</p>
              </figcaption>
            </figure>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<figure className="text-center">
  <div className="text-4xl mb-2"></div>
  <figcaption className="text-xs">
    <p className="text-slate-300">Title</p>
    <p className="text-slate-500">Subtitle</p>
  </figcaption>
</figure>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Bordered Caption</label>
            <figure className="border border-slate-600 rounded-lg p-3">
              <div className="bg-slate-800 h-28 rounded mb-2 flex items-center justify-center text-slate-500">[Image]</div>
              <figcaption className="text-xs space-y-1">
                <p className="text-slate-300 font-medium">Figure 1: Data Analysis Results</p>
                <p className="text-slate-500">Shows the quarterly performance metrics with 15% growth</p>
              </figcaption>
            </figure>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<figure className="border p-3 rounded">
  <img />
  <figcaption className="text-xs space-y-1">
    <p className="text-slate-300 font-medium">Title</p>
    <p className="text-slate-500">Description</p>
  </figcaption>
</figure>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Side-by-Side</label>
            <div className="flex gap-3">
              <div className="bg-slate-800 w-24 h-24 rounded flex items-center justify-center text-slate-500 flex-shrink-0">[Img]</div>
              <div className="text-xs">
                <p className="text-slate-300 font-medium">Media Title</p>
                <p className="text-slate-500 mt-1">Short description of the media content goes here</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-3">
  <img className="w-24 h-24" />
  <div className="text-xs">
    <p className="text-slate-300">Title</p>
    <p className="text-slate-500">Description</p>
  </div>
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED CAPTIONS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Gallery Caption</label>
            <div className="bg-slate-950 rounded p-2 space-y-1">
              <div className="bg-slate-800 h-24 rounded flex items-center justify-center text-slate-500">[Image]</div>
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-xs text-slate-200 font-medium">landscape.jpg</p>
                  <p className="text-xs text-slate-500">2.4 MB  JPG</p>
                </div>
                <span className="text-xs text-slate-500">5/24</span>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-slate-950 rounded p-2">
  <img className="h-24" />
  <div className="flex justify-between">
    <div>
      <p className="text-xs font-medium">File</p>
      <p className="text-xs text-slate-500">Size</p>
    </div>
  </div>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaCaption;


